import React from "react";

type SignContractProps = {};

const SignContract: React.FC<SignContractProps> = () => {
  return <div>Have a good coding</div>;
};
export default SignContract;
